import { Flex } from '@shared/components';

import { type SelectUsersCountBaseProps, SelectUsersCount } from '../../components';
import type { UserListOptions } from '../../types';
import { UserSearchFilterBox } from '../search-and-filter';
import { type UserDataGridProps, UserDataGrid, UserDataGridForm } from '../user-data-grid';

interface BaseUserListProps {
  dataGridProps?: UserDataGridProps;
  selectUsersCountProps?: SelectUsersCountBaseProps;
  options?: UserListOptions;
}

export function BaseUserList(props: Readonly<BaseUserListProps>) {
  const {
    options,
    dataGridProps = {
      rows: [],
      isLoading: false,
      totalCount: 0,
      sx: { minHeight: '100%', flexGrow: 1 },
    },
    selectUsersCountProps,
  } = props;

  return (
    <Flex sx={{ flexDirection: 'column', minHeight: 1, flexGrow: 1 }}>
      <UserSearchFilterBox {...options} />
      {options?.withSelectCountText ? (
        <SelectUsersCount {...selectUsersCountProps} sx={{ mb: 4, alignItems: 'center' }} />
      ) : null}
      {options?.withForm ? (
        <UserDataGridForm {...dataGridProps} />
      ) : (
        <UserDataGrid {...dataGridProps} />
      )}
    </Flex>
  );
}
